module.exports = __webpack_public_path__ + "img/bg.114d0ae8.jpg";